import styled from 'styled-components';

import { media } from '@theme/media';
import { COLORS } from '@theme/colors';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${media.tablet} {
    height: 100%;
    padding: 50px 0;
  }

  ${media.bigDesktop} {
    padding-left: 200px;
  }
`;

export const Container = styled.div`
  position: relative;
  overflow: hidden;
  background-color: ${COLORS.ALTO};

  ${media.tablet} {
    background-color: transparent;
    border: 1px solid ${COLORS.BLACK};
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CloseButton = styled.div`
  border: 1px solid black;
  border-radius: 50%;
  width: 17px;
  height: 17px;
  cursor: pointer;
  position: absolute;
  right: 16px;
  top: 16px;
  z-index: 4;
  display: none;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 3px;
    left: 7px;
    height: 9px;
    width: 1px;
    background-color: ${COLORS.BLACK};
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }

  ${media.tablet} {
    display: block;
  }
`;

export const Canvas = styled.canvas<{ show: boolean }>`
  display: ${({ show }) => (show ? 'block' : 'none')};
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  cursor: ${({ show }) => (show ? 'crosshair' : 'auto')};
`;
